import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'qvs-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
  standalone: true,
  imports: [IonicModule, NgIf]
})
export class PageHeaderComponent {
  @Input() title: string;
  @Input() condense = false;
}
